'use strict';

/**
 * @ngdoc service
 * @name ntmApp.ListGridConstants
 * @description
 * # ListGridConstants
 * Service in the ntmApp.
 */

angular.module('ntmApp')
  .factory('ProfileConstants', function () {

      var constants = {};

      constants.TabTypes = {
          GRID: 'grid',
          PAGE: 'page',
          ROOMPREVIEW: 'roomPreview'
      };

      constants.EditTypes = {
          ADD: 0,
          EDIT: 1
      };

      constants.FilterGroups = {
          ItemInformation: 'itemInformation',
          ItemGrid: 'itemGrid',
          SpecificRecord: 'specificRecord'
      };

      constants.DefaultNames = {
          AddButtonName: 'Add New Data Record'
      };

      constants.AlertTypes = {
          MissingStaffWorkShift: 'MissingStaffWorkShift',
          MissingEquipment: 'MissingEquipment',
          MissingMetrics: 'MissingMetrics',
          MissingRackItem: 'MissingRackItem',
          MissingRacks: 'MissingRacks',
          MissingRecurrence: 'MissingRecurrence',
          MissingSquareFootage: 'MissingSquareFootage'
      };

      constants.ShowInGroupingRowsOptions = {
          AssignedStaffInitials: 'Assigned Staff Initials',
          SpecialActivityIcons: 'Special Activity Icons'
      };

      constants.DisableFieldsInStaffSection = {
          StaffPageSectionId: '400805',
          StaffInfoTabSectionId: '401129',
          SectionAttributeIdsToDisable: [
            "413957",
            "413954",
            "413958",
            "413967",
            "413964",
            "413955",
            "413968",
            "413952",
            "413942",
            "413962",
            "413950",
            "413946",
            "413956",
            "413960",
            "413966",
            "413948",
            "413961"
          ]
      }

      constants.ProfilePages = {
          Rooms: '400807'
      }

      return constants;

  });